"use strict";
/*
 * Created on 14. 1. 2020
 *
 * Copyright (c) 2020 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var PriceFormulas_1 = require("../../core/model/math/PriceFormulas");

var RoundedProductPrice_1 = require("./RoundedProductPrice");
/**
 * Regular product price.
 * @author Radek Beran
 */


var RegularProductPrice =
/*#__PURE__*/
function (_RoundedProductPrice_) {
  _inherits(RegularProductPrice, _RoundedProductPrice_);

  /**
   * @param value value of price
   * @param valueRounded value of the price rounded according to rounding rules
   * @param vatRate VAT rate in percent
   */
  function RegularProductPrice(value, valueRounded, vatRate) {
    var _this;

    _classCallCheck(this, RegularProductPrice);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RegularProductPrice).call(this, value, valueRounded));
    _this.value = value;
    _this.valueRounded = valueRounded;
    _this.vatRate = vatRate;
    return _this;
  }

  _createClass(RegularProductPrice, [{
    key: "getValueWithoutVAT",

    /**
     * Returns value without VAT (LOG-5292).
     */
    value: function getValueWithoutVAT() {
      return this.vatRate === null ? this.getPresentedValue() : this.getPresentedValue() !== null ? PriceFormulas_1.PriceFormulas.computeNetPrice(this.getPresentedValue(), this.vatRate) : null;
    }
  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new RegularProductPrice(mat.value, mat.valueRounded, mat.vatRate);
    }
  }]);

  return RegularProductPrice;
}(RoundedProductPrice_1.RoundedProductPrice);

exports.RegularProductPrice = RegularProductPrice;

RegularProductPrice.productPriceSchema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(RegularProductPrice.name);
  return {
    value: builder.opt(builder.bigNum('value')),
    valueRounded: builder.opt(builder.bigNum('valueRounded')),
    vatRate: builder.opt(builder.bigNum('vatRate'))
  };
}();